/**
 * MKS-550 — MIRROR of `backend/src/constants/billabilityLabels.ts`.
 *
 * Everything from the first `export` below is identical to that file, and
 * `backend/tests/billabilityLabelConstantsParity.test.ts` fails CI the moment the two
 * drift. Edit the backend copy and paste it here; do not edit only one.
 *
 * Why a mirror rather than a shared module: `backend/Dockerfile` and `frontend/Dockerfile`
 * are each built with their own directory as the Docker build context
 * (`docker-compose.production.yml:9` and `:36`), so `../shared` exists in neither image —
 * the same reason `constants/merchSizes.ts` is mirrored.
 */

/** The label a billable project carries. */
export const BILLABLE_LABEL_NAME = 'Billable';

/** The label a non-billable project carries. */
export const NON_BILLABLE_LABEL_NAME = 'Non-billable';

/** Both of them, for an `in` filter or a name test. */
export const BILLABILITY_LABEL_NAMES = [BILLABLE_LABEL_NAME, NON_BILLABLE_LABEL_NAME] as const;

export type BillabilityLabelName = (typeof BILLABILITY_LABEL_NAMES)[number];

/** The one label name that matches the flag. */
export function billabilityLabelNameFor(billable: boolean): BillabilityLabelName {
  return billable ? BILLABLE_LABEL_NAME : NON_BILLABLE_LABEL_NAME;
}

/** Is this label name one of the two? A null / unnamed label never is. */
export function isBillabilityLabelName(name: string | null | undefined): boolean {
  return name != null && (BILLABILITY_LABEL_NAMES as readonly string[]).includes(name);
}
